import { render, staticRenderFns } from "./CondimentItem.vue?vue&type=template&id=3ac656b5&scoped=true&"
import script from "./CondimentItem.vue?vue&type=script&lang=ts&"
export * from "./CondimentItem.vue?vue&type=script&lang=ts&"
import style0 from "./CondimentItem.vue?vue&type=style&index=0&id=3ac656b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac656b5",
  null
  
)

export default component.exports